/** "$1,234.56"; a negative amount carries its sign BEFORE the symbol, "-$0.13",
 * never "$-0.13" (F7). Half away from zero on the exact value, as Intl rounds. */
export const fmtMoney = (n: number): string =>
  (n < 0 ? '-' : '') + '$' + Math.abs(n).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** The cents fmtMoney would print for `n` - the same Intl rounding - so a
 * total built from displayed parts adds up on the page. */
export const displayCents = (n: number): number => {
  const abs = Number(Math.abs(n).toLocaleString('en-US', { useGrouping: false, minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  return Math.round(abs * 100) * (n < 0 ? -1 : 1);
};

export const fmtInt = (n: number): string => Math.round(n).toLocaleString('en-GB');

export const fmtPct = (n: number): string => n.toFixed(1) + '%';

/** 2026-09-01 → "01 Sep" */
export const mmdd = (day: string): string => {
  const d = new Date(day + 'T00:00:00Z');
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', timeZone: 'UTC' });
};

export const todayIso = (): string => new Date().toISOString().slice(0, 10);

export const shiftDays = (day: string, n: number): string => {
  const d = new Date(day + 'T00:00:00Z');
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};

/** The server's all-time window (read/profit.ts profitWindow(0)): from the
 * epoch the app counts from, through today. */
export const ALL_TIME_FROM = '2000-01-01';

/** Range selector semantics shared with /api/profit: positive = trailing
 * window, negative = that single calendar day, 0 = all time through today.
 * Never a window with from > to (F7). */
export function rangeFor(days: number): { from: string; to: string } {
  const today = todayIso();
  if (days < 0) {
    const d = shiftDays(today, days);
    return { from: d, to: d };
  }
  if (days === 0) return { from: ALL_TIME_FROM, to: today };
  // n days ENDING YESTERDAY: the crawls, both bills and the P&L card all stop
  // there, so the tiles, chart and daily table are on the same days (N3).
  return { from: shiftDays(today, -days), to: shiftDays(today, -1) };
}
